<script>
    import { createEventDispatcher } from "svelte";
    import { StarFill } from "../../index";
    let cls = "sui-rate";
    const dispatch = createEventDispatcher();
    export let count = 5;

    export let inActiveColor = "#eee";
    export let activeColor = "#ffd21e";
    export let defaultValue = 0;
    export let allowClear = true;
    export let readOnly = false;

    function handleChange(index) {
        if (readOnly) return;
        if (allowClear && index === defaultValue) {
            defaultValue = 0;
        } else {
            defaultValue = index;
        }
        dispatch("change", defaultValue);
    }
</script>

<div class={cls}>
    {#each Array(count) as _, index}
        <div class={`${cls}-item`} on:click={() => handleChange(index + 1)}>
            <StarFill
                size={24}
                color={defaultValue >= index + 1 ? activeColor : inActiveColor}
            />
        </div>
    {/each}
</div>

<style lang="less">
    @import "./rate.less";
</style>
